// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { DisplayNamedFragmentDoc, NamedFragmentDoc } from '../../../../../fragments/commonFragments.generated';
import { HistoryFeedInfoFragmentDoc, TradePartnerFragmentDoc, TradePartnerContactFragmentDoc, PotentialOperationDetailsFragmentDoc, ChangeEventTypeFragmentDoc } from '../../../../../queries/fragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ScopeTemplatesReviewStepQueryVariables = Types.Exact<{
  filter: Types.ItemTemplateFilter;
  devFilter: Types.DevelopmentFilter;
  itivFilter: Types.ItemTemplateItemVersionFilter;
}>;


export type ScopeTemplatesReviewStepQuery = { __typename?: 'Query', itemTemplates: Array<{ __typename?: 'ItemTemplate', totalCostInCents: number, id: string, name: string, basedOn?: { __typename?: 'ItemTemplate', totalCostInCents: number, id: string, name: string } | null | undefined, canActivate: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }>, itemTemplateItemVersions: Array<{ __typename?: 'ItemTemplateItemVersion', id: string, name: string, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, name: string } } }>, scopeChangeReasons: Array<{ __typename?: 'ScopeChangeReason', id: string, name: string }>, developments: Array<{ __typename?: 'Development', id: string, readyPlans: Array<{ __typename?: 'ReadyPlan', id: string, name: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string }>, itemTemplates: Array<{ __typename?: 'ItemTemplate', id: string }> }> }> };

export type ScopeTemplatesReviewStepTableQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.ItemTemplateFilter>;
}>;


export type ScopeTemplatesReviewStepTableQuery = { __typename?: 'Query', itemTemplates: Array<{ __typename?: 'ItemTemplate', displayName: string, scopeChangeReasonNote?: string | null | undefined, totalCostInCents: number, id: string, name: string, scopeChangeReason?: { __typename?: 'ScopeChangeReason', id: string, name: string } | null | undefined, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string } | null | undefined, basedOn?: { __typename?: 'ItemTemplate', totalCostInCents: number, id: string, name: string } | null | undefined }> };

export type ScopeTemplateItemsReviewStepTableQueryVariables = Types.Exact<{
  filter: Types.ItemTemplateItemVersionFilter;
  order?: Types.InputMaybe<Array<Types.ItemTemplateItemVersionOrder> | Types.ItemTemplateItemVersionOrder>;
}>;


export type ScopeTemplateItemsReviewStepTableQuery = { __typename?: 'Query', itemTemplateItemVersionsPage: { __typename?: 'ItemTemplateItemVersionsPage', items: Array<{ __typename?: 'ItemTemplateItemVersion', id: string, name: string, displayName: string, totalCostInCents: number, scopeChangeType: Types.ScopeChangeType, scopeChangeReasonNote?: string | null | undefined, otherOptionIds: Array<string>, elevationIds: Array<string>, specOptionIds: Array<string>, template: { __typename?: 'ItemTemplate', id: string }, scopeChangeReason?: { __typename?: 'ScopeChangeReason', id: string, name: string } | null | undefined, scope: { __typename?: 'ItemTemplateItem', id: string, basedOn?: { __typename?: 'ItemTemplateItem', totalCostInCents: number, id: string, name: string } | null | undefined }, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, options: Array<{ __typename?: 'ReadyPlanOption', shortName?: string | null | undefined, id: string, name: string }> }> } };

export type SaveScopeChangeReasonReviewStepMutationVariables = Types.Exact<{
  itInput: Types.SaveItemTemplatesInput;
  itivInput: Types.SaveItemTemplateItemVersionsInput;
}>;


export type SaveScopeChangeReasonReviewStepMutation = { __typename?: 'Mutation', saveItemTemplates: { __typename?: 'SaveItemTemplatesResult', itemTemplates?: Array<{ __typename?: 'ItemTemplate', displayName: string, scopeChangeReasonNote?: string | null | undefined, totalCostInCents: number, id: string, name: string, scopeChangeReason?: { __typename?: 'ScopeChangeReason', id: string, name: string } | null | undefined, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string } | null | undefined, basedOn?: { __typename?: 'ItemTemplate', totalCostInCents: number, id: string, name: string } | null | undefined } | null | undefined> | null | undefined }, saveItemTemplateItemVersions: { __typename?: 'SaveItemTemplateItemVersionsResult', itemTemplateItemVersions: Array<{ __typename?: 'ItemTemplateItemVersion', id: string, name: string, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, name: string } } }> } };

export type ActivateTemplateVersionsReviewStepMutationVariables = Types.Exact<{
  input: Types.ActivateItemTemplateVersionsInput;
}>;


export type ActivateTemplateVersionsReviewStepMutation = { __typename?: 'Mutation', activateItemTemplateVersions: { __typename?: 'ActivateItemTemplateVersionsResult', activatedTemplates: Array<{ __typename?: 'ItemTemplate', id: string, activatedAt?: Types.Scalars['DateTime']['input'] | null | undefined, statusDetail: { __typename?: 'ItemTemplateStatusDetail', code: Types.ItemTemplateStatus, name: string }, canCreateNewVersion: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }> } };

export type ScopeTemplatesReviewStepItemTemplateFragment = { __typename?: 'ItemTemplate', totalCostInCents: number, id: string, name: string, basedOn?: { __typename?: 'ItemTemplate', totalCostInCents: number, id: string, name: string } | null | undefined, canActivate: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } };

export type ScopeTemplatesReviewStepItemTemplateTableFragment = { __typename?: 'ItemTemplate', displayName: string, scopeChangeReasonNote?: string | null | undefined, totalCostInCents: number, id: string, name: string, scopeChangeReason?: { __typename?: 'ScopeChangeReason', id: string, name: string } | null | undefined, readyPlan?: { __typename?: 'ReadyPlan', id: string, displayName: string } | null | undefined, basedOn?: { __typename?: 'ItemTemplate', totalCostInCents: number, id: string, name: string } | null | undefined };

export type ScopeTemplatesReviewStepItemTemplateItemVersionFragment = { __typename?: 'ItemTemplateItemVersion', id: string, name: string, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, name: string } } };

export type ScopeTemplatesReviewStepItemTemplateItemVersionTableFragment = { __typename?: 'ItemTemplateItemVersion', id: string, name: string, displayName: string, totalCostInCents: number, scopeChangeType: Types.ScopeChangeType, scopeChangeReasonNote?: string | null | undefined, otherOptionIds: Array<string>, elevationIds: Array<string>, specOptionIds: Array<string>, template: { __typename?: 'ItemTemplate', id: string }, scopeChangeReason?: { __typename?: 'ScopeChangeReason', id: string, name: string } | null | undefined, scope: { __typename?: 'ItemTemplateItem', id: string, basedOn?: { __typename?: 'ItemTemplateItem', totalCostInCents: number, id: string, name: string } | null | undefined }, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }, options: Array<{ __typename?: 'ReadyPlanOption', shortName?: string | null | undefined, id: string, name: string }> };

export const ScopeTemplatesReviewStepItemTemplateFragmentDoc = gql`
    fragment ScopeTemplatesReviewStepItemTemplate on ItemTemplate {
  ...Named
  totalCostInCents
  basedOn {
    ...Named
    totalCostInCents
  }
  canActivate {
    ...PotentialOperationDetails
  }
}
    ${NamedFragmentDoc}
${PotentialOperationDetailsFragmentDoc}`;
export const ScopeTemplatesReviewStepItemTemplateTableFragmentDoc = gql`
    fragment ScopeTemplatesReviewStepItemTemplateTable on ItemTemplate {
  ...Named
  displayName
  scopeChangeReasonNote
  scopeChangeReason {
    id
    name
  }
  readyPlan {
    id
    displayName
  }
  totalCostInCents
  basedOn {
    ...Named
    totalCostInCents
  }
}
    ${NamedFragmentDoc}`;
export const ScopeTemplatesReviewStepItemTemplateItemVersionFragmentDoc = gql`
    fragment ScopeTemplatesReviewStepItemTemplateItemVersion on ItemTemplateItemVersion {
  ...Named
  item {
    id
    costCode {
      ...Named
    }
  }
}
    ${NamedFragmentDoc}`;
export const ScopeTemplatesReviewStepItemTemplateItemVersionTableFragmentDoc = gql`
    fragment ScopeTemplatesReviewStepItemTemplateItemVersionTable on ItemTemplateItemVersion {
  id
  name
  displayName
  totalCostInCents
  scopeChangeType
  scopeChangeReasonNote
  template {
    id
  }
  scopeChangeReason {
    id
    name
  }
  scope {
    id
    basedOn {
      ...Named
      totalCostInCents
    }
  }
  item {
    id
    costCode {
      id
      displayName
    }
  }
  options {
    ...Named
    shortName
  }
  otherOptionIds
  elevationIds
  specOptionIds
}
    ${NamedFragmentDoc}`;
export const ScopeTemplatesReviewStepDocument = gql`
    query ScopeTemplatesReviewStep($filter: ItemTemplateFilter!, $devFilter: DevelopmentFilter!, $itivFilter: ItemTemplateItemVersionFilter!) {
  itemTemplates(filter: $filter) {
    ...ScopeTemplatesReviewStepItemTemplate
  }
  itemTemplateItemVersions(filter: $itivFilter) {
    ...ScopeTemplatesReviewStepItemTemplateItemVersion
  }
  scopeChangeReasons {
    id
    name
  }
  developments(filter: $devFilter) {
    id
    readyPlans {
      ...Named
      options {
        ...Named
      }
      itemTemplates {
        id
      }
    }
  }
}
    ${ScopeTemplatesReviewStepItemTemplateFragmentDoc}
${ScopeTemplatesReviewStepItemTemplateItemVersionFragmentDoc}
${NamedFragmentDoc}`;

/**
 * __useScopeTemplatesReviewStepQuery__
 *
 * To run a query within a React component, call `useScopeTemplatesReviewStepQuery` and pass it any options that fit your needs.
 * When your component renders, `useScopeTemplatesReviewStepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScopeTemplatesReviewStepQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      devFilter: // value for 'devFilter'
 *      itivFilter: // value for 'itivFilter'
 *   },
 * });
 */
export function useScopeTemplatesReviewStepQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ScopeTemplatesReviewStepQuery, ScopeTemplatesReviewStepQueryVariables> & ({ variables: ScopeTemplatesReviewStepQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ScopeTemplatesReviewStepQuery, ScopeTemplatesReviewStepQueryVariables>(ScopeTemplatesReviewStepDocument, options);
      }
export function useScopeTemplatesReviewStepLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ScopeTemplatesReviewStepQuery, ScopeTemplatesReviewStepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ScopeTemplatesReviewStepQuery, ScopeTemplatesReviewStepQueryVariables>(ScopeTemplatesReviewStepDocument, options);
        }
// @ts-ignore
export function useScopeTemplatesReviewStepSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ScopeTemplatesReviewStepQuery, ScopeTemplatesReviewStepQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ScopeTemplatesReviewStepQuery, ScopeTemplatesReviewStepQueryVariables>;
export function useScopeTemplatesReviewStepSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ScopeTemplatesReviewStepQuery, ScopeTemplatesReviewStepQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ScopeTemplatesReviewStepQuery | undefined, ScopeTemplatesReviewStepQueryVariables>;
export function useScopeTemplatesReviewStepSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ScopeTemplatesReviewStepQuery, ScopeTemplatesReviewStepQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ScopeTemplatesReviewStepQuery, ScopeTemplatesReviewStepQueryVariables>(ScopeTemplatesReviewStepDocument, options);
        }
export type ScopeTemplatesReviewStepQueryHookResult = ReturnType<typeof useScopeTemplatesReviewStepQuery>;
export type ScopeTemplatesReviewStepLazyQueryHookResult = ReturnType<typeof useScopeTemplatesReviewStepLazyQuery>;
export type ScopeTemplatesReviewStepSuspenseQueryHookResult = ReturnType<typeof useScopeTemplatesReviewStepSuspenseQuery>;
export type ScopeTemplatesReviewStepQueryResult = Apollo.QueryResult<ScopeTemplatesReviewStepQuery, ScopeTemplatesReviewStepQueryVariables>;
export const ScopeTemplatesReviewStepTableDocument = gql`
    query ScopeTemplatesReviewStepTable($filter: ItemTemplateFilter) {
  itemTemplates(filter: $filter) {
    ...ScopeTemplatesReviewStepItemTemplateTable
  }
}
    ${ScopeTemplatesReviewStepItemTemplateTableFragmentDoc}`;

/**
 * __useScopeTemplatesReviewStepTableQuery__
 *
 * To run a query within a React component, call `useScopeTemplatesReviewStepTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useScopeTemplatesReviewStepTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScopeTemplatesReviewStepTableQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useScopeTemplatesReviewStepTableQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ScopeTemplatesReviewStepTableQuery, ScopeTemplatesReviewStepTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ScopeTemplatesReviewStepTableQuery, ScopeTemplatesReviewStepTableQueryVariables>(ScopeTemplatesReviewStepTableDocument, options);
      }
export function useScopeTemplatesReviewStepTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ScopeTemplatesReviewStepTableQuery, ScopeTemplatesReviewStepTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ScopeTemplatesReviewStepTableQuery, ScopeTemplatesReviewStepTableQueryVariables>(ScopeTemplatesReviewStepTableDocument, options);
        }
// @ts-ignore
export function useScopeTemplatesReviewStepTableSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ScopeTemplatesReviewStepTableQuery, ScopeTemplatesReviewStepTableQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ScopeTemplatesReviewStepTableQuery, ScopeTemplatesReviewStepTableQueryVariables>;
export function useScopeTemplatesReviewStepTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ScopeTemplatesReviewStepTableQuery, ScopeTemplatesReviewStepTableQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ScopeTemplatesReviewStepTableQuery | undefined, ScopeTemplatesReviewStepTableQueryVariables>;
export function useScopeTemplatesReviewStepTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ScopeTemplatesReviewStepTableQuery, ScopeTemplatesReviewStepTableQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ScopeTemplatesReviewStepTableQuery, ScopeTemplatesReviewStepTableQueryVariables>(ScopeTemplatesReviewStepTableDocument, options);
        }
export type ScopeTemplatesReviewStepTableQueryHookResult = ReturnType<typeof useScopeTemplatesReviewStepTableQuery>;
export type ScopeTemplatesReviewStepTableLazyQueryHookResult = ReturnType<typeof useScopeTemplatesReviewStepTableLazyQuery>;
export type ScopeTemplatesReviewStepTableSuspenseQueryHookResult = ReturnType<typeof useScopeTemplatesReviewStepTableSuspenseQuery>;
export type ScopeTemplatesReviewStepTableQueryResult = Apollo.QueryResult<ScopeTemplatesReviewStepTableQuery, ScopeTemplatesReviewStepTableQueryVariables>;
export const ScopeTemplateItemsReviewStepTableDocument = gql`
    query ScopeTemplateItemsReviewStepTable($filter: ItemTemplateItemVersionFilter!, $order: [ItemTemplateItemVersionOrder!]) {
  itemTemplateItemVersionsPage(filter: $filter, order: $order) {
    items {
      ...ScopeTemplatesReviewStepItemTemplateItemVersionTable
    }
  }
}
    ${ScopeTemplatesReviewStepItemTemplateItemVersionTableFragmentDoc}`;

/**
 * __useScopeTemplateItemsReviewStepTableQuery__
 *
 * To run a query within a React component, call `useScopeTemplateItemsReviewStepTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useScopeTemplateItemsReviewStepTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScopeTemplateItemsReviewStepTableQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useScopeTemplateItemsReviewStepTableQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ScopeTemplateItemsReviewStepTableQuery, ScopeTemplateItemsReviewStepTableQueryVariables> & ({ variables: ScopeTemplateItemsReviewStepTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ScopeTemplateItemsReviewStepTableQuery, ScopeTemplateItemsReviewStepTableQueryVariables>(ScopeTemplateItemsReviewStepTableDocument, options);
      }
export function useScopeTemplateItemsReviewStepTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ScopeTemplateItemsReviewStepTableQuery, ScopeTemplateItemsReviewStepTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ScopeTemplateItemsReviewStepTableQuery, ScopeTemplateItemsReviewStepTableQueryVariables>(ScopeTemplateItemsReviewStepTableDocument, options);
        }
// @ts-ignore
export function useScopeTemplateItemsReviewStepTableSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ScopeTemplateItemsReviewStepTableQuery, ScopeTemplateItemsReviewStepTableQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ScopeTemplateItemsReviewStepTableQuery, ScopeTemplateItemsReviewStepTableQueryVariables>;
export function useScopeTemplateItemsReviewStepTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ScopeTemplateItemsReviewStepTableQuery, ScopeTemplateItemsReviewStepTableQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ScopeTemplateItemsReviewStepTableQuery | undefined, ScopeTemplateItemsReviewStepTableQueryVariables>;
export function useScopeTemplateItemsReviewStepTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ScopeTemplateItemsReviewStepTableQuery, ScopeTemplateItemsReviewStepTableQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ScopeTemplateItemsReviewStepTableQuery, ScopeTemplateItemsReviewStepTableQueryVariables>(ScopeTemplateItemsReviewStepTableDocument, options);
        }
export type ScopeTemplateItemsReviewStepTableQueryHookResult = ReturnType<typeof useScopeTemplateItemsReviewStepTableQuery>;
export type ScopeTemplateItemsReviewStepTableLazyQueryHookResult = ReturnType<typeof useScopeTemplateItemsReviewStepTableLazyQuery>;
export type ScopeTemplateItemsReviewStepTableSuspenseQueryHookResult = ReturnType<typeof useScopeTemplateItemsReviewStepTableSuspenseQuery>;
export type ScopeTemplateItemsReviewStepTableQueryResult = Apollo.QueryResult<ScopeTemplateItemsReviewStepTableQuery, ScopeTemplateItemsReviewStepTableQueryVariables>;
export const SaveScopeChangeReasonReviewStepDocument = gql`
    mutation SaveScopeChangeReasonReviewStep($itInput: SaveItemTemplatesInput!, $itivInput: SaveItemTemplateItemVersionsInput!) {
  saveItemTemplates(input: $itInput) {
    itemTemplates {
      ...ScopeTemplatesReviewStepItemTemplateTable
    }
  }
  saveItemTemplateItemVersions(input: $itivInput) {
    itemTemplateItemVersions {
      ...ScopeTemplatesReviewStepItemTemplateItemVersion
    }
  }
}
    ${ScopeTemplatesReviewStepItemTemplateTableFragmentDoc}
${ScopeTemplatesReviewStepItemTemplateItemVersionFragmentDoc}`;
export type SaveScopeChangeReasonReviewStepMutationFn = Apollo.MutationFunction<SaveScopeChangeReasonReviewStepMutation, SaveScopeChangeReasonReviewStepMutationVariables>;

/**
 * __useSaveScopeChangeReasonReviewStepMutation__
 *
 * To run a mutation, you first call `useSaveScopeChangeReasonReviewStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveScopeChangeReasonReviewStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveScopeChangeReasonReviewStepMutation, { data, loading, error }] = useSaveScopeChangeReasonReviewStepMutation({
 *   variables: {
 *      itInput: // value for 'itInput'
 *      itivInput: // value for 'itivInput'
 *   },
 * });
 */
export function useSaveScopeChangeReasonReviewStepMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveScopeChangeReasonReviewStepMutation, SaveScopeChangeReasonReviewStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveScopeChangeReasonReviewStepMutation, SaveScopeChangeReasonReviewStepMutationVariables>(SaveScopeChangeReasonReviewStepDocument, options);
      }
export type SaveScopeChangeReasonReviewStepMutationHookResult = ReturnType<typeof useSaveScopeChangeReasonReviewStepMutation>;
export type SaveScopeChangeReasonReviewStepMutationResult = Apollo.MutationResult<SaveScopeChangeReasonReviewStepMutation>;
export type SaveScopeChangeReasonReviewStepMutationOptions = Apollo.BaseMutationOptions<SaveScopeChangeReasonReviewStepMutation, SaveScopeChangeReasonReviewStepMutationVariables>;
export const ActivateTemplateVersionsReviewStepDocument = gql`
    mutation ActivateTemplateVersionsReviewStep($input: ActivateItemTemplateVersionsInput!) {
  activateItemTemplateVersions(input: $input) {
    activatedTemplates {
      id
      activatedAt
      statusDetail {
        code
        name
      }
      canCreateNewVersion {
        ...PotentialOperationDetails
      }
      canDelete {
        ...PotentialOperationDetails
      }
    }
  }
}
    ${PotentialOperationDetailsFragmentDoc}`;
export type ActivateTemplateVersionsReviewStepMutationFn = Apollo.MutationFunction<ActivateTemplateVersionsReviewStepMutation, ActivateTemplateVersionsReviewStepMutationVariables>;

/**
 * __useActivateTemplateVersionsReviewStepMutation__
 *
 * To run a mutation, you first call `useActivateTemplateVersionsReviewStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateTemplateVersionsReviewStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateTemplateVersionsReviewStepMutation, { data, loading, error }] = useActivateTemplateVersionsReviewStepMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActivateTemplateVersionsReviewStepMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ActivateTemplateVersionsReviewStepMutation, ActivateTemplateVersionsReviewStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ActivateTemplateVersionsReviewStepMutation, ActivateTemplateVersionsReviewStepMutationVariables>(ActivateTemplateVersionsReviewStepDocument, options);
      }
export type ActivateTemplateVersionsReviewStepMutationHookResult = ReturnType<typeof useActivateTemplateVersionsReviewStepMutation>;
export type ActivateTemplateVersionsReviewStepMutationResult = Apollo.MutationResult<ActivateTemplateVersionsReviewStepMutation>;
export type ActivateTemplateVersionsReviewStepMutationOptions = Apollo.BaseMutationOptions<ActivateTemplateVersionsReviewStepMutation, ActivateTemplateVersionsReviewStepMutationVariables>;